import React from 'react';
import { useLocation } from 'react-router-dom';

import EmailOptInTrigger from 'core/modules/EmailOptInTrigger/EmailOptInTrigger';
import RedirectToTargetLandingPage from 'core/modules/RedirectToTargetLandingPage/RedirectToTargetLandingPage';
import PageErrorBoundary from 'core/modules/ErrorBoundaries/PageErrorBoundary';

import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import SponsoredTextOffers from 'core/modules/SponsoredTextOffers/SponsoredTextOffers';
import CategoryMerchantsTable from 'core/modules/CategoryMerchantsTable/CategoryMerchantsTable';
import LetterboxTOF from 'core/modules/LetterboxTOF/LetterboxTOF';

function CategoryPage() {
  const { pathname } = useLocation();

  const { categoryName } = window;
  const categoryId = pathname.match(/bc_(\d+)/)[1];

  return (
    <RedirectToTargetLandingPage>
      <PageErrorBoundary>
        <SectionTitle title={categoryName} />
        <LetterboxTOF letterbox_category_id={categoryId} />
        <SponsoredTextOffers category_id={categoryId} section_title="Featured offers" />
        <CategoryMerchantsTable category_id={categoryId} categoryName={categoryName} />
      </PageErrorBoundary>
      <EmailOptInTrigger />
    </RedirectToTargetLandingPage>
  );
}

export default CategoryPage;
